import { getApiMessage } from '../components/alliance/api-message';

/**
 * The API's message from a failed request, for inline error alerts, else
 * `fallback`. See getApiMessage for the response shapes it reads.
 *
 * @param error - The query or mutation error (an Amplify/axios error)
 * @param fallback - Shown when the API sent no message
 */
export const getErrorMessage = (params: { error: unknown; fallback: string }) =>
  getApiMessage(params.error) || params.fallback;
